module.exports = __webpack_public_path__ + "img/no-car-image.4384cf3c.png";